import React, { FC, useEffect } from 'react'
import logo from './react.svg'
import styles from './Home.module.scss'
import { HomeStore } from './HomeStore'
import { observer } from 'mobx-react-lite'
import { useRoutes } from 'routing/routes'

import {initializeChat} from 'external/YlChat';

interface Props {
  store: HomeStore
}



export const Home: FC<Props> = observer(function Home({ store }) {

  const routes = useRoutes()
  useEffect(()=>{
    initializeChat('en-US')
  },[])
  return (
    <div className={styles.Home}>
      Home to test kustomer chat.....
    </div>
  )
})
